module.exports = __webpack_public_path__ + "img/exit-fullscreen.49ac46b4.svg";